/**
 * Maps patrimonio/equity value to tier classification for RDStation
 * Based on client classification ranges:
 * - Tier 1: 5M - 10M
 * - Tier 2: 1M - 5M
 * - Tier 3: 350k - 1M
 * 
 * @param {number} value - The patrimonio/equity value
 * @returns {string} The tier classification or empty string if outside ranges
 */
export const getTierClassification = (value) => {
  if (!value || isNaN(value) || value < 0) {
    return '';
  }

  const numValue = Number(value);

  // Tier 1: 5M - 10M
  if (numValue >= 5000000 && numValue <= 10000000) {
    return 'Tier 1 - (5M - 10M)';
  }

  // Tier 2: 1M - 5M
  if (numValue >= 1000000 && numValue < 5000000) {
    return 'Tier 2 - (1M - 5M)';
  }

  // Tier 3: 350k - 1M
  if (numValue >= 350000 && numValue < 1000000) {
    return 'Tier 3 - (350k - 1M)';
  }

  // Outside defined ranges
  return '';
};

